<div *ngIf="accountId" style="margin-top: 25px;">
  <react-webcomponent></react-webcomponent>
</div>
<app-group-list url="media-dashboard"> </app-group-list>
